import { SellerScheduleClient } from './seller-schedule-client';
export default function SchedulePage() { return <SellerScheduleClient />; }
